import { isObject } from "lodash-es";
import isRangeWithinRange from "./isRangeWithinRange";
import isPositionWithinRange from "./isPositionWithinRange";
export default function isRangeOrPositionWithinRange(rangeOrPositionToCheck, containingRange, maxLength, includeStartEdge, includeEndEdge) {
  if (rangeOrPositionToCheck === void 0 || rangeOrPositionToCheck === null || containingRange === void 0 || containingRange === null) {
    return false;
  }
  if (isObject(rangeOrPositionToCheck)) {
    return isRangeWithinRange(
      rangeOrPositionToCheck,
      containingRange,
      maxLength
    );
  } else {
    return isPositionWithinRange(
      rangeOrPositionToCheck,
      containingRange,
      maxLength,
      includeStartEdge,
      includeEndEdge
    );
  }
}
